import { useCallback, useState } from 'react';

function normalizeKeys(keys) {
  if (keys instanceof Set) return [...keys];
  if (Array.isArray(keys)) return keys;
  if (keys == null || keys === '') return [];
  return [keys];
}

/**
 * 图片网格「禁用」状态：禁用项不参与下载/导出等业务，可通过卡片角标恢复。
 */
export default function useGalleryDisabledKeys(initialKeys = []) {
  const [disabledKeys, setDisabledKeys] = useState(
    () => new Set(normalizeKeys(initialKeys).map(String).filter(Boolean)),
  );

  const disableKeys = useCallback((keys) => {
    const incoming = normalizeKeys(keys);
    if (incoming.length === 0) return;
    setDisabledKeys((prev) => {
      const next = new Set(prev);
      incoming.forEach((key) => {
        const id = String(key);
        if (id) next.add(id);
      });
      return next;
    });
  }, []);

  const restoreKey = useCallback((key) => {
    const id = String(key);
    if (!id) return;
    setDisabledKeys((prev) => {
      if (!prev.has(id)) return prev;
      const next = new Set(prev);
      next.delete(id);
      return next;
    });
  }, []);

  const isDisabled = useCallback(
    (key) => disabledKeys.has(String(key)),
    [disabledKeys],
  );

  const filterEnabledKeys = useCallback((keys) => {
    const list = keys instanceof Set ? [...keys] : normalizeKeys(keys);
    return list.filter((key) => !disabledKeys.has(String(key)));
  }, [disabledKeys]);

  const clearDisabled = useCallback(() => {
    setDisabledKeys(new Set());
  }, []);

  return {
    disabledKeys,
    disableKeys,
    restoreKey,
    isDisabled,
    filterEnabledKeys,
    clearDisabled,
  };
}
